// @ts-nocheck
import { FEATURE_PREVIEWS_ERROR, FEATURE_PREVIEWS_LOADING, FEATURE_PREVIEWS_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const FeaturePreviewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FEATURE_PREVIEWS_LOADING:
            return Object.assign({}, state, { loading: true })
        case FEATURE_PREVIEWS_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case FEATURE_PREVIEWS_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

